export enum DataType {
  Temporal = "temporal",
  Quantitative = "quantitative",
  Nominal = "nominal",
}
